export default () => {
  function itemWidth(track) {
    const item = track.children[0];
    if (!item) return 72;
    const gap = parseFloat(getComputedStyle(track).gap) || 8;
    return item.offsetWidth + gap;
  }

  function visibleCount(viewport, track) {
    return Math.floor(viewport.offsetWidth / itemWidth(track));
  }

  function maxOffset(viewport, track) {
    return Math.max(0, track.children.length - visibleCount(viewport, track));
  }

  function initCarousel(el) {
    if (el._carouselAbort) el._carouselAbort.abort();
    const controller = new AbortController();
    el._carouselAbort = controller;
    const { signal } = controller;

    const track = el.querySelector('[data-timetable-carousel-target="track"]');
    const viewport = el.querySelector('[data-timetable-carousel-target="viewport"]');
    const prevBtn = el.querySelector('[data-timetable-carousel-target="prev"]');
    const nextBtn = el.querySelector('[data-timetable-carousel-target="next"]');

    if (!track || !viewport || !prevBtn || !nextBtn) return;

    let offset = 0;

    const activeItem = track.querySelector('.timetable-date-nav__day--active');
    if (activeItem) {
      const activeIndex = Array.from(track.children).indexOf(activeItem);
      offset = Math.min(activeIndex, maxOffset(viewport, track));
    }

    function update() {
      track.style.transform = `translateX(-${offset * itemWidth(track)}px)`;
      prevBtn.classList.toggle('timetable-date-nav__arrow--disabled', offset <= 0);
      nextBtn.classList.toggle('timetable-date-nav__arrow--disabled', offset >= maxOffset(viewport, track));
    }

    prevBtn.addEventListener('click', () => {
      if (offset > 0) { offset--; update(); }
    }, { signal });

    nextBtn.addEventListener('click', () => {
      if (offset < maxOffset(viewport, track)) { offset++; update(); }
    }, { signal });

    let hasDragged = false;
    let dragStartX = 0;
    let dragStartOffset = 0;
    let dragRawOffset = 0;

    function applyDrag(clientX) {
      const delta = clientX - dragStartX;
      if (Math.abs(delta) > 4) hasDragged = true;
      dragRawOffset = Math.max(0, Math.min(maxOffset(viewport, track), dragStartOffset - delta / itemWidth(track)));
      track.style.transform = `translateX(-${dragRawOffset * itemWidth(track)}px)`;
    }

    function endDrag() {
      track.style.transition = '';
      offset = Math.round(dragRawOffset);
      update();
    }

    // Mouse drag — listen on document so fast moves don't lose the drag
    viewport.addEventListener('mousedown', (e) => {
      hasDragged = false;
      dragStartX = e.clientX;
      dragStartOffset = offset;
      dragRawOffset = offset;
      track.style.transition = 'none';

      function onMouseMove(ev) { applyDrag(ev.clientX); }
      function onMouseUp() {
        endDrag();
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }, { signal });

    viewport.addEventListener('dragstart', (e) => e.preventDefault(), { signal });

    // Touch drag
    viewport.addEventListener('touchstart', (e) => {
      hasDragged = false;
      dragStartX = e.touches[0].clientX;
      dragStartOffset = offset;
      dragRawOffset = offset;
      track.style.transition = 'none';
    }, { signal, passive: true });

    viewport.addEventListener('touchmove', (e) => {
      applyDrag(e.touches[0].clientX);
    }, { signal });

    viewport.addEventListener('touchend', () => {
      endDrag();
    }, { signal });

    // Suppress navigation if the mouse moved during mousedown (i.e. was a drag not a click)
    viewport.addEventListener('click', (e) => {
      if (hasDragged) {
        e.preventDefault();
        e.stopImmediatePropagation();
        hasDragged = false;
      }
    }, { signal, capture: true });

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-controller="timetable-carousel"]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();

    [document.getElementById('timetables-items'), document.getElementById('timetable-date-nav-wrapper')]
      .filter(Boolean)
      .forEach(el => new MutationObserver(initAll).observe(el, { childList: true }));
  });
};
